import { MouseEvent } from 'react';

import clsx from 'clsx';
import camelCase from 'lodash/camelCase';
import { NavLink } from 'react-router-dom';

import classes from './NavBar.module.css';

export type TNavMenuItem = {
  to: string;
  title: string;
  dataTestId?: string;
  dropdownLinks?: Omit<TNavMenuItem, 'onToggleMenu'>[];
  exact?: boolean;
  onClick?(): void;
  onToggleMenu(): void;
  isDropdownMenu?: boolean;
};

function NavMenuItem({
  isDropdownMenu,
  dropdownLinks,
  dataTestId,
  to,
  title,
  onClick,
  onToggleMenu,
  exact = false,
}: TNavMenuItem) {
  function handleClick(e: MouseEvent<HTMLAnchorElement>) {
    if (e.currentTarget.href === window.location.href) {
      e.preventDefault();
      onToggleMenu();
    }
  }

  return isDropdownMenu ? (
    <div className={classes.menu_listItem_dropdown} data-testid={dataTestId}>
      <button className={classes.menu_listItem_link} type="button">
        {title}
        <i
          className={clsx(
            classes.menu_listItem_dropdown_icon,
            'fas',
            'fa-caret-down'
          )}
        />
      </button>
      <div
        data-testid={`dropdown-${camelCase(title)}`}
        className={classes.menu_listItem_dropdown_content}
      >
        <button className={classes.menu_listItem_link} type="button">
          {title}
          <i
            className={clsx(
              classes.menu_listItem_dropdown_icon,
              'fas',
              'fa-caret-down'
            )}
          />
        </button>
        {dropdownLinks &&
          dropdownLinks.map(
            (
              item: Omit<
                TNavMenuItem,
                'dropdownLinks' | 'isDropdownMenu' | 'onToggleMenu'
              >
            ) => (
              <NavMenuItem
                key={item.to || item.title}
                {...{ ...item, onToggleMenu }}
              />
            )
          )}
      </div>
    </div>
  ) : (
    <li className={classes.menu_listItem}>
      {to?.[0] === '/' ? (
        <NavLink
          to={to}
          className={classes.menu_listItem_link}
          activeClassName={classes.is_active}
          onClick={handleClick}
          data-testid={dataTestId}
          exact={exact}
        >
          {title}
        </NavLink>
      ) : (
        <a
          href={to}
          className={classes.menu_listItem_link}
          onClick={onClick || handleClick}
          data-testid={dataTestId}
        >
          {title}
        </a>
      )}
    </li>
  );
}

export default NavMenuItem;
